module.exports = __webpack_public_path__ + "img/p3.e232c557.png";